import { Tooltip } from 'antd'

const DefaultPolicy = {
  minLength: 8,
  requireUppercase: true,
  requireLowercase: true,
  requireNumbers: true,
  requireSymbols: true,
}

export const validatePassword = () => (_, password) => {
  const policy = DefaultPolicy
  if (password && policy) {
    if (password.length < policy.minLength) {
      return Promise.reject(`パスワードは${policy.minLength}文字以上である必要があります`)
    }
    if (policy.requireUppercase && !/[A-Z]/.test(password)) {
      return Promise.reject('パスワードに大文字を含めてください')
    }
    if (policy.requireLowercase && !/[a-z]/.test(password)) {
      return Promise.reject('パスワードに小文字を含めてください')
    }
    if (policy.requireNumbers && !/[0-9]/.test(password)) {
      return Promise.reject('パスワードに数字を含めてください')
    }
    if (policy.requireSymbols && !/[\^$\*\.\[\]\{\}\(\)\?"!@#%&\/\\,><':;\|_~`=\+\-]/.test(password)) {
      return Promise.reject('パスワードに記号を含めてください')
    }
  }

  return Promise.resolve()
}

export const passwordPolicyDescription = () => {
  const requireList = []
  const policy = DefaultPolicy
  if (policy.requireUppercase) {
    requireList.push('大文字')
  }
  if (policy.requireLowercase) {
    requireList.push('小文字')
  }
  if (policy.requireNumbers) {
    requireList.push('数字')
  }
  if (policy.requireSymbols) {
    requireList.push(
      <Tooltip
        key="symbol"
        color="white"
        overlayInnerStyle={{ color: 'black' }}
        title={
          <>
            使用できる記号：
            <br />
            <code>^ $ * . [ ] &#123; &#125; ( ) ? " ! @ # % &amp; / \ , &gt; &lt; ' : ; | _ ~ ` = + -</code>
          </>
        }>
        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>記号</span>
      </Tooltip>,
    )
  }
  if (requireList.length === 0) {
    return `アルファベット${policy.minLength}文字以上`
  }
  return (
    <span>
      アルファベットの
      {requireList.map((item, idx) => (
        <span key={idx}>
          {idx > 0 && '・'}
          {item}
        </span>
      ))}
      を含めた{policy.minLength}文字以上
    </span>
  )
}
